import gsap from 'gsap';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

import { GetBy } from "../_app/cuchillo/core/Element";
import { isDebug } from '../_app/cuchillo/core/Basics';
import { Ease } from '../_app/cuchillo/utils/Ease';

export default class Preloader {
    _container;
    _logo;
    _lines;
    _cols;
    _paths;

    static init() {
        this._container = GetBy.id('Preloader');

        if (isDebug) {
            this._container.style.display = "none";
            return;
        }

        this._logo = GetBy.class('icon', this._container);
        gsap.set(this._logo, { opacity: 1 });

        this._lines = GetBy.selector('.grid-lines span', this._container);
        gsap.set(this._lines, { height: 0, opacity: 1 });

        this._cols = GetBy.selector('.grid-cols span', this._container);
        gsap.set(this._cols, { scaleX: 0, opacity: 1 });

        this._paths = GetBy.selector('.logo-full svg', this._container);
        gsap.set(this._paths, { y: '100%' });
    }

    static update(__progress) { }

    static hide(__call) {
        if (isDebug) {
            if (__call) __call();
            this._container.style.display = "none";
            return;
        }

        let delay = .5;

        for (let i = 1; i < this._lines.length; i++) {
            const line = this._lines[i];
            gsap.to(line, {
                height: '100%',
                delay: delay + i * .2,
                duration: 1.5,
                ease: Ease.EASE_CUCHILLO_IN_OUT,
            });
        }

        delay += .5;
        for (let i = 0; i < this._paths.length; i++) {
            const path = this._paths[i];
            gsap.to(path, {
                y: 0,
                delay: delay + i * .2,
                duration: 1.5,
                ease: Ease.EASE_CUCHILLO_IN_OUT,
            });
        }

        delay += 3;
        gsap.to(this._logo, {
            scale: .7,
            delay,
            duration: 1.4,
            ease: Ease.EASE_CUCHILLO_IN_OUT
        });

        // delay += .5;
        for (let i = 0; i < this._cols.length; i++) {
            const line = this._cols[i];
            line.style.transformOrigin = 'center left';

            gsap.to(line, {
                scaleX: 1,
                delay: delay + i * .3,
                duration: 1.5,
                ease: Ease.EASE_CUCHILLO_IN_OUT,
                onComplete: () => {
                    line.style.transformOrigin = 'center right';
                }
            });
        }

        delay += 3;
        gsap.to(this._logo, {
            opacity: 0,
            delay,
            duration: .5,
            ease: Ease.EASE_CUCHILLO_IN_OUT
        });

        for (let i = 0; i < this._cols.length; i++) {
            const line = this._cols[i];
            gsap.to(line, {
                scaleX: 0,
                delay: delay + i * .15,
                duration: 1,
                ease: Ease.EASE_CUCHILLO_IN_OUT,
            });
        }

        delay += 1;
        gsap.to(this._container, {
            opacity: 0,
            delay,
            duration: 1,
            ease: Ease.EASE_CUCHILLO_IN_OUT,
            onComplete: () => {
                this._container.style.display = "none";
                if (__call) __call();
            }
        });
    }
}
